export const SEARCH_ANSWERS_STORAGE_KEY = 'fmnavi:search-answers';

export const SEARCH_TYPE_STORAGE_KEY = 'fmnavi:search-type';

export const FEATURE_FLAGS_STORAGE_KEY = 'fmnavi:feature-flags';